<div class="flex-1">
  <div class="p-2 w-full">
    <div class="flex flex-col h-full justify-between">
      <div class="flex flex-row items-center justify-between">
        <div>
          <span class="font-medium mr-1 text-md">
            {{ title }} (Last {{ duration | kpiDisplayDuration }})
            <mat-icon inline *ngIf="tooltip">info</mat-icon>
          </span>
        </div>
      </div>
      <span class="font-medium text-2xl leading-none {{ currentClass }}">
        {{
          cents
            ? (currentValue | currencyInPennies: 'USD':'symbol':numberFormat)
            : (currentValue | number: numberFormat)
        }}
      </span>
      <div class="flex flex-col">
        <div class="flex flex-row items-center justify-between whitespace-nowrap">
          <div class="text-gray-600">Previous {{ duration | kpiDisplayDuration }}</div>
          <div class="text-gray-600">
            {{
              cents
                ? (priorValue | currencyInPennies: 'USD':'symbol':numberFormat)
                : (priorValue | number: numberFormat)
            }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div [class]="loading ? 'visible' : 'invisible'">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
</div>
